import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sort-block" }
const _hoisted_2 = {
  class: "select select--small search-bar--sort",
  style: {"display":"flex","align-items":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_app_dropdown = _resolveComponent("app-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "select__label",
        style: _normalizeStyle({
                    width: _ctx.unsetFixedWidth ? undefined : '4.0625rem',
                    'align-items': 'center',
                    'text-transform': 'none',
                    'font-size': _ctx.fontSize,
                })
      }, [
        _createVNode(_component_i18n_t, { keypath: "ourCars.sortBy" })
      ], 4),
      _createVNode(_component_app_dropdown, {
        modelValue: _ctx.sortModel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sortModel) = $event)),
        fontSize: _ctx.fontSize,
        type: "single",
        "show-checkbox": false,
        options: _ctx.sortOptions,
        "get-value": (option) => option.configuration,
        "get-label": (option) => option.description,
        placeholder: _ctx.placeholder
      }, null, 8, ["modelValue", "fontSize", "options", "get-value", "get-label", "placeholder"])
    ])
  ]))
}